export function observeStickyScrollPadding(
  header: HTMLElement,
  footer: HTMLElement | null,
  scrollRoot: HTMLElement = document.documentElement,
): () => void {
  const topProperty = '--k-scroll-padding-top';
  const bottomProperty = '--k-scroll-padding-bottom';
  const previousTop = scrollRoot.style.getPropertyValue(topProperty);
  const previousBottom = scrollRoot.style.getPropertyValue(bottomProperty);
  let active = true;
  const offset = (height: number) => (height > 0 ? Math.ceil(height) + 12 : 0);
  const update = () => {
    if (!active) return;
    scrollRoot.style.setProperty(topProperty, offset(header.getBoundingClientRect().height) + 'px');
    scrollRoot.style.setProperty(
      bottomProperty,
      offset(footer?.getBoundingClientRect().height ?? 0) + 'px',
    );
  };
  update();
  const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(update);
  observer?.observe(header);
  if (footer) observer?.observe(footer);
  window.addEventListener('resize', update);
  return () => {
    active = false;
    observer?.disconnect();
    window.removeEventListener('resize', update);
    if (previousTop) scrollRoot.style.setProperty(topProperty, previousTop);
    else scrollRoot.style.removeProperty(topProperty);
    if (previousBottom) scrollRoot.style.setProperty(bottomProperty, previousBottom);
    else scrollRoot.style.removeProperty(bottomProperty);
  };
}
